import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Router} from '@angular/router';

@Component({
    selector: 'modal-assessment-landing',
    templateUrl: './modal-assessment-landing.page.html',
    styleUrls: ['./modal-assessment-landing.page.scss'],
})
export class ModalAssessmentLandingPage implements OnInit {


    constructor(public router: Router, public modalController: ModalController) {
    }

    ngOnInit() {
    }

    dismiss() {
        this.modalController.dismiss();
    }

}
